// JsFromRoutes CacheKey 8c8bbb27e8611f6bf304e6210124dcee
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from 'utils/js_from_routes_client'

export default {
  index: /* #__PURE__ */ definePathHelper('get', '/broker/clients/:client_id/employees'),
  show: /* #__PURE__ */ definePathHelper('get', '/broker/employees/:id'),
}
